import apiClient from '@u/apiClient'
import GetPersonListController from '@/wayfinder/actions/App/Http/Controllers/Person/GetPersonListController'
import SearchPersonController from '@/wayfinder/actions/App/Http/Controllers/Person/SearchPersonController'
import GetPersonByIdController from '@/wayfinder/actions/App/Http/Controllers/Person/GetPersonByIdController'
import GetInvoiceableByIdController from '@/wayfinder/actions/App/Http/Controllers/Person/GetInvoiceableByIdController'
import CreatePersonController from '@/wayfinder/actions/App/Http/Controllers/Person/CreatePersonController'
import UpdatePersonController from '@/wayfinder/actions/App/Http/Controllers/Person/UpdatePersonController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async fetchPersonList({ commit }) {
    await apiClient
      .route(GetPersonListController.get())
      .then(async (response) => {
        await commit('setPersonList', response.data.people)
      })
      .catch(async (reason) => {
        await console.error('fetchPersonList', reason)
      })
  },
  fetchNewPerson: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'person' } }))
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  searchForAPerson: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SearchPersonController.get(), {
          params: payload.query
        })
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async searchForAPersonLocal({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/search-person?${payload.query}`)
        .then(async (response) => {
          resolve(response.data.personList)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  FetchPersonById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPersonByIdController.get({ mergeablePerson: payload.person_id })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoiceableById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceableByIdController.get({
            invoiceable: payload.invoiceable_id
          }),
          {
            params: { type: payload.invoiceable_type }
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async storePerson({ commit }, payload) {
    await apiClient
      .route(CreatePersonController.post(), payload.person)
      .then(async (response) => {
        if (response.status === 200) {
          commit('setPerson', response.data.person)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('storePerson', reason)
      })
  },

  updatePerson: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdatePersonController.put({ person: payload.person_id }),
          payload.person
        )
        .then((response) => {
          // voir pour supprimer ceci
          if (response.status === 200) {
            commit('setPerson', response.data.person)
            processSuccessCallback(payload)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
